import { getErrorMessage } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import { toast } from 'react-toastify';
import type { Exercice } from '@mairistem/comptabilite';
import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import { updateBordereau } from '../../../services/piecesComptables/bordereaux/bordereaux';
import BordereauEtat from '../../../constants/liquidation/bordereaux/BordereauEtat';
import Tdt from '../../../interfaces/common/Tdt';

class BordereauEmettreLeFluxAction extends BaseLiquidationAction<BordereauWithState, BordereauActionType> {
  constructor(options: BaseLiquidationOptions) {
    super(options);
    this.label = 'Émettre le flux';
    this.type = BordereauActionType.EMETTRE_LE_FLUX;
  }

  execute = (bordereau: BordereauWithState, exercice: Exercice): TreeviewActionResult<BordereauWithState> => {
    const urlParam = new URLSearchParams();

    if (bordereau.identifiantExercice) {
      urlParam.append('identifiantExercice', bordereau.identifiantExercice.toString());
    }
    if (bordereau.identifiant) {
      urlParam.append('identifiantBordereau', bordereau.identifiant.toString());
    }
    if (bordereau.typePes) {
      urlParam.append('typeBordereau', bordereau.typePes);
    }
    if (bordereau.identifiantEntite) {
      urlParam.append('identifiantEntite', bordereau.identifiantEntite.toString());
    }

    const data = {
      ...bordereau,
      etat: exercice.entite.tdtIxchange2 === Tdt.IXCHANGE2 ? BordereauEtat.TRAITEMENT_PES_EN_INSTANCE : '',
      acquitte: 0,
      anomalieAck: '',
      motifEchec: '',
    };

    const result = request
      .get<unknown, { url: string }>(`/api/finances/comptabilite/pes/url?${urlParam.toString()}`)
      .then(({ url }) => {
        window.open(url);
        return updateBordereau(data, new URLSearchParams({
          withJournaux: 'true',
        }));
      })
      .catch((error) => {
        toast.error(getErrorMessage(error.message, "Impossible d'émettre le flux PES"));
        throw error;
      });

    return {
      result,
      type: ActionResultType.UPDATE,
    };
  };
}

export default BordereauEmettreLeFluxAction;
